// app-checkout-bridge.js
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    if (!body || !body.classList.contains("app-checkout-bridge")) return;

    const U = window.EVR && window.EVR.GuardUtils;
    if (!U) {
      console.error("[app-checkout-bridge] Missing EVR.GuardUtils (evr-guard-utils.js not loaded?)");
      return;
    }

    const main = document.querySelector("main") || document.querySelector("#MainContent");
    if (main) main.style.visibility = "hidden";

    const overlay = U.createThemeOverlay({ initialText: "Zugriff wird geprüft …" });

    const setText = (t) => overlay.setText(t);
    const setHtml = (h) => overlay.setHtml(h);

    (async function run() {
      try {
        const env = U.resolveEnvFromUrlAndStorage();
        await U.autoLoginFromUrlIfPresent(env);

        setText("Anmeldung wird geprüft …");
        const user = await U.ensureFirebaseUser(env, 5000);
        if (!user) {
          if (main) main.style.visibility = "visible";
          setHtml(
            '<div class="evr-odg__title">Anmeldung erforderlich</div>' +
              '<div class="evr-odg__text">Bitte öffne diesen Link direkt aus der EVERSION-App.</div>' +
              '<a class="evr-odg__link" href="/">Zur Startseite</a>'
          );
          return;
        }

        const firebaseIdToken = await U.getFirebaseIdTokenOrNull(user);
        if (!firebaseIdToken) {
          if (main) main.style.visibility = "visible";
          setHtml(
            '<div class="evr-odg__title">Anmeldung fehlgeschlagen</div>' +
              '<div class="evr-odg__text">Bitte öffne den Link erneut aus der EVERSION-App.</div>' +
              '<a class="evr-odg__link" href="/">Zur Startseite</a>'
          );
          return;
        }

        setText("Dein Warenkorb wird vorbereitet …");

        // hardcoded / injected config
        const variantId =
          (window.EVR && window.EVR.appCheckoutVariantId && String(window.EVR.appCheckoutVariantId)) ||
          (document.body && document.body.getAttribute("data-app-checkout-variant")) ||
          "55930362626379";

        const cartToken = await U.replaceCartWithSingleVariant({
          variantId,
          quantity: 1,
          properties: { _evr_app_checkout: "1", _evr_env: env },
        });

        await U.mergeCartAttributes({
          evr_app_checkout: "1",
          evr_env: env,
          evr_uid: String(user.uid || ""),
          evr_cart_token: String(cartToken || ""),
        });

        setText("Bestelldaten werden vorbereitet …");
        const prefill = await U.fetchCheckoutPrefill({ firebaseIdToken });

        const origin = window.location.origin;
        const coupon = U.getCouponFromUrl();

        setText("Weiterleitung zur Kasse …");

        if (prefill) {
          const checkoutUrl = U.buildCheckoutPrefillUrl({ origin, prefill });
          U.redirectToCheckoutWithOptionalCoupon({ checkoutUrl, coupon });
          return;
        }

        // fallback
        if (coupon) {
          window.location.href = `${origin}/discount/${encodeURIComponent(coupon)}?redirect=/checkout`;
          return;
        }
        window.location.href = "/checkout";
      } catch (err) {
        console.error("[app-checkout-bridge] Fatal error:", err);
        try {
          overlay.destroy();
        } catch (_) {}
        window.location.href = "/";
      }
    })();
  });
})();
